import { FacetsData } from 'mk2/apps/bazaar/components/FacetsFilter';
import {
    HerBazaarLoadApiFailureAction,
    HerBazaarLoadApiRequestAction,
    HerBazaarLoadApiSuccessAction,
    HER_BAZAAR_LOAD_API_FAILURE,
    HER_BAZAAR_LOAD_API_REQUEST,
    HER_BAZAAR_LOAD_API_SUCCESS,
} from 'mk2/apps/bazaar/containers/HerBazaar/HerBazaar.actions';
import { hashFilter } from 'mk2/apps/bazaar/helpers/filter';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

type HerBazaarPerSellerActions =
    | HerBazaarLoadApiRequestAction
    | HerBazaarLoadApiSuccessAction
    | HerBazaarLoadApiFailureAction;

export interface PerFilterState {
    loadingState: LoadingState;
    errorMessage: string;
    facets: FacetsData;
    hits: number;
    productsIds: number[];
    checked: {
        [productId: number]: true;
    };
    complaintsPerProductIds: {
        [productId: number]: number[];
    };
}

export const perFilterInitialState: PerFilterState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    hits: null,
    facets: null,
    productsIds: [],
    checked: {},
    complaintsPerProductIds: {},
};

const perFilterReducer: Reducer<PerFilterState> = (
    state: PerFilterState = perFilterInitialState,
    action: HerBazaarPerSellerActions,
) => {
    switch (action.type) {
        case HER_BAZAAR_LOAD_API_REQUEST:
        case HER_BAZAAR_LOAD_API_FAILURE:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        case HER_BAZAAR_LOAD_API_SUCCESS:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                hits: action.hits,
                facets: action.facets,
                productsIds: action.response.result.products,
                complaintsPerProductIds: action.response.result.complaints,
                checked: action.checked,
            };
        default:
            return state;
    }
};

export interface PerSellerState {
    sellerId: number;
    filters: {
        [filterHash: string]: PerFilterState;
    };
}

export const perSellerInitialState: PerSellerState = {
    sellerId: null,
    filters: {},
};

const perSellerReducer: Reducer<PerSellerState> = (
    state: PerSellerState = perSellerInitialState,
    action: HerBazaarPerSellerActions,
) => {
    let hash;
    switch (action.type) {
        case HER_BAZAAR_LOAD_API_REQUEST:
        case HER_BAZAAR_LOAD_API_FAILURE:
            hash = hashFilter(action.filter);
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [hash]: perFilterReducer(state.filters[hash], action),
                },
            };
        case HER_BAZAAR_LOAD_API_SUCCESS:
            hash = hashFilter(action.filter);
            return {
                ...state,
                sellerId: action.response.result.seller,
                filters: {
                    ...state.filters,
                    [hash]: perFilterReducer(state.filters[hash], action),
                },
            };
        default:
            return state;
    }
};

export interface State {
    sellers: {
        [username: string]: PerSellerState;
    };
}

export const initialState: State = {
    sellers: {},
};

const reducer: Reducer<State> = (state: State = initialState, action: HerBazaarPerSellerActions) => {
    switch (action.type) {
        case HER_BAZAAR_LOAD_API_REQUEST:
        case HER_BAZAAR_LOAD_API_FAILURE:
            return {
                ...state,
                sellers: {
                    ...state.sellers,
                    [action.username]: perSellerReducer(state.sellers[action.username], action),
                },
            };
        case HER_BAZAAR_LOAD_API_SUCCESS:
            return {
                ...state,
                sellers: {
                    ...state.sellers,
                    [action.username]: perSellerReducer(state.sellers[action.username], action),
                },
            };
        default:
            return state;
    }
};

export default reducer;
